/**
 配置管理--电站列表
 */
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { Modal, Form, Input, message } from "antd";
import moment from "moment";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import fetchHandler from "@/fetch/fetchHandler";
import {
  getStubGroupList,
  getCityList,
  prefixFile,
  updateStubRemark,
} from "../../../fetch/fetchApi";
import RefreshGrid from "../../../utils/refreshGrid";
import { useAuth } from "@/utils/utils";
// eslint-disable-next-line arrow-parens
const opType = {
  0: [
    {
      text: "全部",
      value: "",
    },
    {
      text: "平台托管联营站",
      value: "0",
    },
    {
      text: "品牌联营站",
      value: "1",
    },
    {
      text: "互联互通联营站",
      value: "2",
    },
    {
      text: "专用开放站",
      value: "3",
    },
    {
      text: "专用内部站",
      value: "4",
    },
    {
      text: "品牌站",
      value: "5",
    },
    // ,
    // {
    //   text: '互联互通站',
    //   value: "7",
    // }
  ],
  1: [
    {
      text: "全部",
      value: "",
    },
    {
      text: "自建站", // '自建站',
      value: "6",
    },
    {
      text: "共建站", // '自建站',
      value: "8",
    },
  ],
};
@connect((state) => state)
class StubGroupList extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    // 设置电站id
    this.queryStubGroupName = "";
    this.initCity = [];
    this.queryStubGroupId = "";
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.operationMode = window.LayoutTab.tabParam.operationMode
        ? window.LayoutTab.tabParam.operationMode
        : "";
      this.powerStationType = window.LayoutTab.tabParam.powerStationType;
      const cityIds = window.LayoutTab.tabParam.cityIds
        ? window.LayoutTab.tabParam.cityIds.split(",")
        : [];
      const provinceIds = window.LayoutTab.tabParam.provinceIds
        ? window.LayoutTab.tabParam.provinceIds.split(",")
        : [];
      if (provinceIds.length > 0) {
        if (provinceIds[0] != "000000") {
          this.initCity.push(provinceIds[0]);
        }
      }
      if (cityIds.length > 0) {
        this.initCity.push(`${cityIds[0].substr(0, 2)}0000`);
        this.initCity.push(cityIds[0]);
        // console.log("dde", this.initCity);
      }
      this.queryStubGroupName = window.LayoutTab.tabParam.stubGroupName
        ? window.LayoutTab.tabParam.stubGroupName
        : "";
      this.queryStubGroupId = window.LayoutTab.tabParam.stubGroupId
        ? window.LayoutTab.tabParam.stubGroupId
        : "";
    }
    this.state = {
      visible: false,
      stationTypeOptions: [
        {
          text: "全部",
          value: "",
        },
      ],
      internationalization: this.props.intl.messages.stubGroupList,
      typeOption: [
        {
          text: this.props.intl.messages.stubGroupList.all, // '全部',
          value: "",
        },
      ],
      seeConsPartyRemarksState: false,
      recordInfo: {},
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.init();
  }

  componentDidMount() {
    // this.fetchApi({});
  }

  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "areaPicker",
          isPickArea: !0,
          placeholder: this.state.internationalization.placeholder1, // '请选择地区',
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
          pickOnSelect: true,
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          // defaultValue: ['34'], //默认值
          required: !1,
          labelName: this.state.internationalization.title1, // '地区',
          className: "allshow",
          sourceApi: getCityList,
          defaultValue: this.initCity.length == 0 ? [] : this.initCity,
        },
        {
          type: "input",
          placeholder: this.state.internationalization.title2, // '电站名称',
          param: {
            name: "stubGroupName",
            type: "string",
          },
          labelName: this.state.internationalization.title2, // '电站名称:',
          required: false,
          defaultValue: this.queryStubGroupName ? this.queryStubGroupName : "",
        },
        {
          type: "input",
          placeholder: "设备编号", // '电站名称',
          param: {
            name: "stubId",
            type: "string",
          },
          labelName: "设备编号", // '电站名称:',
          required: false,
          defaultValue: "",
        },
        {
          type: "select",
          options: [
            {
              text: this.state.internationalization.all, // '全部',
              value: "",
            },
            {
              text: this.state.internationalization.title8, // '',
              value: "1",
            },
            {
              text: this.state.internationalization.title7, // '',
              value: "0",
            },
          ],
          placeholder: this.state.internationalization.title6, // '请选择运营类型',
          param: {
            name: "type",
            type: "string",
          },
          labelName: this.state.internationalization.btn6, // '运营类型',
          required: false,
          onChange: (e, form) => {
            form.setFieldsValue({
              powerStationType: "",
              operationMode: e,
            });
            let stationTypeOptions = [];
            if (e && e != null && e != "") {
              stationTypeOptions = opType[e];
            }
            this.setState(
              {
                stationTypeOptions: stationTypeOptions,
              },
              () => {
                this.setState({
                  formConfig: this.initFormConfig(),
                });
              },
            );
          },
          defaultValue: this.operationMode ? this.operationMode : "",
        },

        {
          type: "select",
          placeholder: "请选择", // '请选择电站类型',
          labelName: "电站类型", // '电站类型',
          param: {
            name: "powerStationType",
            type: "string",
          },
          options: this.state.stationTypeOptions,
          required: false,
          defaultValue: this.powerStationType ? this.powerStationType : "",
        },
        {
          type: "select",
          options: [
            {
              text: this.state.internationalization.all, // '全部',
              value: "",
            },
            {
              text: "上线", // '公共',
              value: "上线",
            },
            {
              text: "关闭下线", // '关闭下线',
              value: "关闭下线",
            },
            {
              text: "建设中", // '建设中',
              value: "建设中",
            },
            {
              text: "维护中", // '维护中',
              value: "维护中",
            },
            {
              text: "禁用", // '禁用',
              value: "禁用",
            },
          ],
          placeholder: this.state.internationalization.title6, // '请选择场站类型',
          param: {
            name: "statusInfo",
            type: "string",
          },
          labelName: "电站状态", // '电站状态',
          required: false,
        },
        {
          type: "select",
          options: [
            {
              text: this.state.internationalization.all, // '全部',
              value: "",
            },
            {
              text: this.state.internationalization.title9, // '公共',
              value: "0",
            },
            {
              text: this.state.internationalization.title10, // '个人',
              value: "1",
            },
            {
              text: this.state.internationalization.title11, // '专用开放',
              value: "2",
            },
            {
              text: this.state.internationalization.title12, // '专用内部',
              value: "3",
            },
          ],
          placeholder: this.state.internationalization.title6, // '请选择场站类型',
          param: {
            name: "stubGroupType",
            type: "string",
          },
          labelName: this.state.internationalization.btn7, // '场站类型',
          required: false,
        },
        {
          type: "select",
          options: [
            {
              text: "自建",
              value: "1",
            },
            {
              text: "代运营",
              value: "2",
            },
          ],
          placeholder: this.state.internationalization.title6, // '请选择',
          param: {
            name: "constructionMode",
            type: "string",
          },
          labelName: "投建方式",
          required: false,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("010101")
              ? {
                  btnType: "submit",
                  // icon:'search',
                  text: this.state.internationalization.btn1, // '查询'
                }
              : "",
            useAuth("010102")
              ? {
                  btnType: "button",
                  text: "导出", // '导出',
                  handler: (e, param) => {
                    // console.log(param);
                    const newParam = param;
                    newParam.token = window.sessionStorage.getItem("token");
                    newParam.companyId = window.sessionStorage.getItem("companyId");
                    let paramString = "";
                    const selectCity = (param.cityId && param.cityId.split(",")) || [];
                    this.init();
                    switch (selectCity.length) {
                      case 1:
                        newParam.cityId = selectCity[0];
                        break;
                      case 2:
                        newParam.cityId = selectCity[1];
                        break;
                      case 3:
                        newParam.cityId = selectCity[2];
                        break;
                      default:
                        newParam.cityId = "";
                        break;
                    }
                    Object.keys(newParam).forEach((key) => {
                      const paraminfo = newParam[key] ? newParam[key] : "";
                      paramString += `${key}=${paraminfo}&`;
                    });
                    delete newParam.token;
                    delete newParam.companyId;
                    this.exportOrderStuGroup(paramString);
                  },
                }
              : "",
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {
        stubGroupName: this.queryStubGroupName ? this.queryStubGroupName : null,
      },
      tableKey: "stubGroupListTable",
    };
    return formConfig;
  };

  init() {
    this.setState({
      tableConfig: {
        tableKey: "stubGroupListTable",
        tableColumns: [
          {
            name: "项目编号",
            key: "projectNumber",
            colType: "textCol",
            align: "left",
          },
          {
            name: "电站ID",
            key: "stubGroupId",
            colType: "textCol",
            align: "left",
            width: 250,
            render: (value, name) => {
              // console.log("id==", value, name);
              return value;
            },
          },
          {
            name: this.state.internationalization.title2, // '电站名称',
            key: "name",
            colType: "textCol",
            render: (value) => {
              if (value.length > 20) {
                return <span title={value}>{value}</span>;
              } else if (value) {
                return value;
              } else {
                return "--";
              }
            },
          },

          {
            name: this.state.internationalization.btn6, // '运营类型'
            key: "type",
            align: "left",
            width: 200,
            colType: "textCol",
            render: (value) => {
              switch (value) {
                case 0:
                  return this.state.internationalization.title7; // '非直营';
                case 1:
                  return this.state.internationalization.title8; // '直营';
                default:
                  return this.state.internationalization.title23; // '未知'
              }
            },
          },
          {
            name: "电站类型", // '场站类型'
            key: "powerStationType",
            align: "left",
            width: 200,
            colType: "textCol",
            render: (value, record) => {
              if (record.type == null) {
                return "--";
              } else if (record.type == 0) {
                if (record.powerStationType == 0) {
                  return "平台托管联营站";
                } else if (record.powerStationType == 1) {
                  return "品牌联营站";
                } else if (record.powerStationType == 2) {
                  return "互联互通联营站";
                } else if (record.powerStationType == 3) {
                  return "专用开放站";
                } else if (record.powerStationType == 4) {
                  return "专用内部站";
                } else if (record.powerStationType == 5) {
                  return "品牌站";
                }
                // else if (record.powerStationType == 7)
                // {
                //   return '互联互通站';
                // }
                else {
                  return "--";
                }
              } else if (record.type == 1) {
                if (record.powerStationType == 6) {
                  return "自建站";
                } else if (record.powerStationType == 8) {
                  return "共建站";
                } else {
                  return "--";
                }
              }
            },
          },
          {
            name: `${this.state.internationalization.title3}(枪)`, // '直流数',
            key: "dcSubCnt",
            colType: "textCol",
            align: "center",
            width: 100,
          },
          {
            name: `${this.state.internationalization.title4}(枪)`, // '交流数',
            key: "acStubCnt",
            colType: "textCol",
            align: "center",
            width: 100,
          },
          {
            name: "启用时间", // '启用时间‘,
            key: "startTime",
            colType: "textCol",
            align: "left",
          },
          {
            name: "首次上线时间", // '首次上线时间',
            key: "firstStartTime",
            colType: "textCol",
            align: "left",
          },
          {
            name: this.state.internationalization.title5, // '电站地区',
            key: "cityName",
            colType: "textCol",
            align: "left",
            width: 250,
          },
          {
            name: "详细地址", // '详细地址',
            key: "address",
            colType: "tipCol",
            align: "left",
            tipNum: 15,
          },
          {
            name: "状态", // '状态',
            key: "statusInfo",
            colType: "tipCol",
            align: "left",
            tipNum: 15,
          },
          {
            name: "投建方式",
            key: "constructionMode",
            colType: "tipCol",
            align: "left",
            tipNum: 15,
            render: (value) => {
              switch (value) {
                case "1":
                  return "自建";
                case "2":
                  return "代运营";
                default:
                  return "--";
              }
            },
          },
          {
            name: "投建方备注",
            key: "constructionRemark",
            colType: "tipCol",
            align: "left",
            tipNum: 15,
          },
          {
            name: this.state.internationalization.action, // '操作',
            key: "action",
            fix: "right",
            width: 250,
            colType: "action",
            actionMap: [
              useAuth("010103")
                ? {
                    type: "href",
                    actionName: this.state.internationalization.btn2, // '设备列表',
                    handler: (record) => {
                      // localStorage.stubGroupId = record.key;
                      // localStorage.stubGroupName = record.name;
                      // 1、公充设备查询，2、墙盒设备查询，3、地锁查询
                      this.openTab(
                        {
                          // keyId: `stub_${record.key}`,
                          StubName: record.name,
                          stubGroupId: record.key,
                        },
                        {
                          key: ["0102", "0110", "0107"][record.redirect - 1],
                          titleText: ["公充设备查询", "墙盒设备查询", "地锁查询"][
                            record.redirect - 1
                          ],
                        },
                      );
                    },
                  }
                : "",
              useAuth("010104")
                ? {
                    type: "href",
                    actionName: "电站信息", // '基础信息',
                    handler: (res) => {
                      this.openTab(
                        {
                          stubId: res.key,
                        },
                        {
                          key: "stubGroupBasicInfo",
                          titleText: "电站信息",
                        },
                      );
                      this.stubInfoData = res;
                      // this.modalVisibleAction('seeDetailVisible', true);
                      // this.setState({
                      //     seeDetailVisible: true
                      // })
                    },
                  }
                : "",
              useAuth("010105")
                ? {
                    type: "href",
                    actionName: "维修记录",
                    handler: (record) => {
                      this.openTab(
                        {
                          stationName: record.name,
                        },
                        {
                          key: "0106",
                          titleText: "维修记录",
                        },
                      );
                    },
                  }
                : "",
              useAuth("010106")
                ? {
                    type: "href",
                    actionName: this.state.internationalization.btn8, // '订单列表',
                    handler: (record) => {
                      // localStorage.stubGroupId = record.key;
                      // localStorage.stubGroupName = record.name;
                      this.openTab(
                        {
                          // keyId: `stub_${record.key}`,
                          StubName: record.name,
                          stubGroupId: record.key,
                        },
                        {
                          key: "0501",
                          titleText: this.state.internationalization.btn8, // '订单列表',
                        },
                      );
                    },
                  }
                : "",
              useAuth("010107")
                ? {
                    type: "confirm",
                    actionName: "导出订单",
                    handler: (record) => {
                      this.exportOrder(record);
                    },
                  }
                : "",
              useAuth("010108")
                ? {
                    type: "href",
                    actionName: this.state.internationalization.btn4, // '配电柜列表',
                    handler: (record) => {
                      // localStorage.stubGroupName = record.name;
                      // localStorage.stubGroupId = record.key;
                      this.openTab(
                        {
                          stubGroupName: record.name,
                          stubGroupId: record.key,
                        },
                        {
                          key: "0104",
                          titleText: this.state.internationalization.btn5, // '配电柜管理'
                        },
                      );
                    },
                  }
                : "",
              // {
              //   type:"href",
              //   actionName:"诊断报告",
              //   handler:(record) => {
              //     this.props.onAdd(
              //       {
              //           key: "10zdbg",
              //           titleText: "诊断报告", // '配电柜管理'
              //       },{
              //           stubGroupName:record.name,
              //           stubGroupId:record.key,
              //       }
              //     )
              //     // this.openTab({
              //     //   stubGroupName:record.name,
              //     //   stubGroupId:record.key,
              //     // }, {
              //     //   key: "10zdbg",
              //     //   titleText: "诊断报告", // '配电柜管理'
              //     // });
              //   }
              // },
              useAuth("010109")
                ? {
                    type: "href",
                    actionName: "电站拓扑图", // '配电柜列表',
                    handler: (record) => {
                      // localStorage.stubGroupName = record.name;
                      // localStorage.stubGroupId = record.key;
                      this.openTab(
                        {
                          stubGroupName: record.name,
                          stubGroupId: record.key,
                        },
                        {
                          key: "stubGroupTobu",
                          titleText: "电站拓扑图", // '配电柜管理'
                        },
                      );
                    },
                  }
                : "",
              useAuth("010110")
                ? {
                    type: "href",
                    actionName: "修改投建方备注",
                    handler: (record) => {
                      this.setState({
                        seeConsPartyRemarksState: true,
                        recordInfo: {
                          ...record,
                          remark: record.constructionRemark,
                        },
                      });
                    },
                  }
                : "",
            ],
          },
        ],
        tableChange: () => {},
        tableParam: {
          type: this.operationMode ? this.operationMode : null,
          powerStationType: this.powerStationType ? this.powerStationType : null,
          pagecount: 10,
          cityId: this.initCity.length == 0 ? null : this.initCity[this.initCity.length - 1],
          stubGroupName: this.queryStubGroupName ? this.queryStubGroupName : null,
        },
        dataApi: getStubGroupList,
        autoRefresh: !0, // 设置为true 直接加载grid数据
      },
    });
  }

  //导出
  exportOrderStuGroup = (paramString) => {
    const excelUrl = `${prefixFile}/exportStationList.do`;

    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${paramString}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${paramString}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  //导出订单
  exportOrder = (record) => {
    // fetchHandler(lockUnBind, {
    //   stubId: record.key,
    // }).then((res) => {
    //   if (res && (res.code === "ok" || res.code === "success")) {
    //     message.success("解绑地锁成功");
    //     RefreshGrid(this.context.store, "stubSearchTable");
    //   }
    // });
    const newParam = {
      cityId: record.city,
      stubGroupId: record.key,
      startTime: moment(new Date()).subtract(29, "d").format("YYYY-MM-DD"),
      endTime: moment(new Date()).format("YYYY-MM-DD"),
    };
    const excelUrl = `${prefixFile}/exportOrderList.do`;
    let paramString = "";
    Object.keys(newParam).forEach((key) => {
      const paraminfo = newParam[key] ? newParam[key] : "";
      paramString += `${key}=${paraminfo}&`;
    });
    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${paramString}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${paramString}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  fetchApi = (param) => {
    // console.log("是否点击");
    const newParam = param;
    const selectCity = (param.cityId && param.cityId.split(",")) || [];
    this.queryStubGroupName = "";
    this.operationMode = "";
    this.powerStationType = "";
    this.initCity = [];
    this.init();
    switch (selectCity.length) {
      case 1:
        newParam.cityId = selectCity[0];
        break;
      case 2:
        newParam.cityId = selectCity[1];
        break;
      case 3:
        newParam.cityId = selectCity[2];
        break;
      default:
        newParam.cityId = "";
        break;
    }
    console.log("fetchApi param:", param);
    return RefreshGrid(this.context.store, "stubGroupListTable", newParam);
  };

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  /**
   * 页面内调用，关闭modal弹窗方法
   */
  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  // 设置Form的ref
  formRef = React.createRef();

  handleSubmit = () => {
    const values = this.formRef.current.getFieldsValue();
    fetchHandler(updateStubRemark, {
      stubGroupId: this.state.recordInfo.stubGroupId,
      ...values,
    })
      .then((res) => {
        if (res && res.code === "success") {
          this.fetchApi({});
          this.modalVisibleAction("seeConsPartyRemarksState", false);
        }
      })
      .catch(() => {
        // console.log(values);
      });
  };

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel">
          <ScGridTable config={this.state.tableConfig} />
        </div>
        <Modal
          title="修改投建方备注"
          visible={this.state.seeConsPartyRemarksState}
          destroyOnClose
          width="500px"
          onOk={this.handleSubmit}
          onCancel={() => {
            this.modalVisibleAction("seeConsPartyRemarksState", false);
          }}>
          <Form
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 16 }}
            ref={this.formRef}
            initialValues={this.state.recordInfo}>
            <Form.Item label="投建方备注" name="remark" style={{ overflow: "inherit" }}>
              <Input.TextArea placeholder="请输入" maxLength={500}></Input.TextArea>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );

    return Content;
  }
}

export default injectIntl(StubGroupList);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stubGroup/stubGroupList.js